// extracted by mini-css-extract-plugin
module.exports = {"root":"ActiveFilters_root__3znQm"};